<template>
  <v-layout row justify-center>
    <v-dialog v-if="linkData" v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon class="pr-2">settings</v-icon>
            Edit Link
          </span>
        </v-card-title>
        <v-card-text class="pb-0">
            <v-form ref="edit_link" data-vv-scope="edit_link" lazy-validation>
              <v-layout row wrap pb-3>
                <v-flex xs12>
                  <v-text-field
                    v-model.number="link"
                    label="Link *"
                    v-validate="'required'"
                    data-vv-name="edit_link.link"
                    :error-messages="errors.collect('edit_link.link')"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="saveLink()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'EditLinkModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['editLinkDialog', 'linkData', 'loading'],
  data () {
    return {
      dialog: this.editLinkDialog,
      link: this.linkData ? this.linkData.target_url.decoded : '',
      dictionary: {
        en: {
          custom: {
            'edit_link.link': {
              required: 'Link required'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    editLinkDialog: {
      handler () {
        this.dialog = this.editLinkDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('editLinkDialog', this.dialog)
      }
    },
    linkData: {
      handler () {
        this.link = this.linkData ? this.linkData.target_url.decoded : ''
      }
    }
  },
  methods: {
    saveLink () {
      this.$validator.validateAll('edit_link').then(res => {
        if (res) {
          this.$parent.$emit('loading', true)

          this.$store.dispatch('EDIT_LINK', { linkId: this.linkData.id, url: this.link }).then(res => {
            this.$parent.$emit('loading', false)
            this.$parent.$emit('updateLinksList')
            this.$toasted.show('Link was successfully edited')
            this.closeModal()
          }, err => {
            console.log('login error', err)
            this.$parent.$emit('loading', false)
            this.$toasted.show('EDIT_LINK ERROR: ' + this.$services.getApiError(err), { type: 'error' })
          })
        }
      })
    },
    closeModal () {
      this.dialog = false
      setTimeout(() => {
        this.$validator.errors.clear('edit_link')
      }, 500)
    },
    clearForm () {
      this.form = {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/edit-link-modal/EditLinkModal.vue